import { render, staticRenderFns } from "./thing_rents.vue?vue&type=template&id=00c74e00&"
import script from "./thing_rents.vue?vue&type=script&lang=js&"
export * from "./thing_rents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports